<template>
  <div class="login-container">
    <top-img-bar />
    <div class="container">
      <div class="row justify-content-center">
        <div class="px-2 card-container" :style="cardSizeStyle">
          <div class="card form-card">
            <div class="logo-container text-center"><i class="logo-round-icon"></i></div>
            <div class="card-body form-card-body">
              <div class="top-section text-center" v-if="$slots.heading || $slots.subHeading">
                <h1 class="form-heading" v-if="$slots.heading">
                  <span class="text-gradient"><slot name="heading"></slot></span>
                </h1>
                <div class="text-normal-1" v-if="$slots.subHeading">
                  <slot name="subHeading"></slot>
                </div>
              </div>
              <slot name="content"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="text-center text-medium-1 mt-4" v-if="$slots.footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
import TopImgBar from '@/views/TopImgBar'

const cardSizeConfig = {
  sm: '450px',
  md: '600px'
}

export default {
  name: 'CardLayout',
  props: {
    cardSize: {
      default: 'sm'
    }
  },
  computed: {
    cardSizeStyle() {
      return `width: min(100vw, ${cardSizeConfig[this.cardSize]})`
    }
  },
  components: {
    TopImgBar
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';
@import '~@/styles/forms';
@import '~@/styles/errors';

.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.form-card {
  background: $white;
  margin-top: 55px;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 3px 20px rgba(162, 162, 162, 0.1), 0px 10px 50px rgba(123, 123, 123, 0.3);
  border-radius: 15px;
  padding: 1rem 0.75rem;
}

.field-error-message {
  padding: 0 $input-padding-x;
}

.top-section {
  padding-top: 12px;
  padding-bottom: 32px;
}

.logo-container {
  position: relative;
  height: 0px;
  top: -40px;
}

.logo-round-icon {
  view-transition-name: round-logo;
}

footer {
  margin-top: auto;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.form-card-body {
  font-weight: normal;
}
.card-container {
  box-sizing: content-box;
}
</style>
